import { render, staticRenderFns } from "./AssetInfo.vue?vue&type=template&id=21555df8&scoped=true"
import script from "./AssetInfo.vue?vue&type=script&lang=js"
export * from "./AssetInfo.vue?vue&type=script&lang=js"
import style0 from "./AssetInfo.vue?vue&type=style&index=0&id=21555df8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21555df8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21555df8')) {
      api.createRecord('21555df8', component.options)
    } else {
      api.reload('21555df8', component.options)
    }
    module.hot.accept("./AssetInfo.vue?vue&type=template&id=21555df8&scoped=true", function () {
      api.rerender('21555df8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Asset/AssetInfo/AssetInfo.vue"
export default component.exports